import React from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { SINGLE_PRODUCT_PATH } from '@constant'
import { Link } from 'react-router'

export default () => {
  let header = [<Link to={SINGLE_PRODUCT_PATH}>单品管理</Link>, '相关案例']

  return (
    <HeaderView title="相关案例" header={header}>
      <div className={styles.wrap}>
        <Link to={SINGLE_PRODUCT_PATH}>
          <img src="//qnm.hunliji.com/o_1d1v5lhca1oo118a1kv21q732rg9.png" />
        </Link>
        <img src="//qnm.hunliji.com/o_1d22b52k9c9n1st115mkcm3e7ie.png" />
        <img src="//qnm.hunliji.com/o_1d1v5mavfqmniq9lcn13091spbj.png" />
      </div>
      <div className={styles.btnBox}>
        <Link to={SINGLE_PRODUCT_PATH}>去设置</Link>
      </div>
    </HeaderView>
  )
}
